function getTitle(vm) {
  const {title} = vm.$options;
  if (title) {
    return typeof title === 'function'
        ? title.call(vm)
        : title;
  }
}

function updateTitle(vm) {
  const title = getTitle(vm);
  if (title) {
    document.title = `Thomas's Portfolio | ${title}`;
  }
}

/**
 * Title mixin, sets the page title depending on the current routes view, and if title has been set in the
 * default exported object.
 */
export default {
  mounted() {
    updateTitle(this);
  },
  methods: {
    updateTitle() {
      updateTitle(this);
    }
  }
};



// WEBPACK FOOTER //
// ./src/util/title.js